import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import { FFTableRowProps } from './types';
import { useFFTableStyles } from './styles';
import FFTableCell from './FFTableCell';

export function FFTableRow<T>({
  row,
  columns,
  onActionClick,
  rowKey,
  onRowClick,
}: FFTableRowProps<T>) {
  const classes = useFFTableStyles();
  const rowId = (row as any)[rowKey];

  return (
    <TableRow
      hover
      tabIndex={-1}
      key={`row-${rowId}`}
      className={onRowClick ? classes.tableRowClickable : classes.tableRow}
      onClick={onRowClick}
    >
      {columns
        .filter((column) => !column.hide)
        .map((column) => {
          const value = (row as any)[column.id];
          return (
            <FFTableCell
              key={`cell-${rowId}-${column.id}`}
              column={column}
              row={row}
              value={value}
              onActionClick={onActionClick}
            />
          );
        })}
    </TableRow>
  );
}

export default FFTableRow;
